<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form class="app-pay-form" @submit.prevent="send">
          <div class="alert alert-danger" style="width:100%;margin-bottom:10px">
              <b>Ödemeyi başlatmadan önce tarayıcınızda pop-up(açılır pencerelere) izin veriniz.</b>
          </div>
          <slot name="content"></slot>
          <ButtonLoader class="primary block" :loader="btnLoading" :text="'Ödemeyi Başlat'" />
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props:['providerInfo'],
    data(){
      return{
        btnLoading: false,
        form: {
            provider    : 'bank',
        },
      }
    },
    created(){
      this.form.provider = this.provider;
    },
    computed: {
        provider() {
            return this.$route.params.payment;
        }
    },
    methods:{
      send() {
        this.btnLoading = true;
        axios.post('/user/wallet/deposit/instapay/create', { ...this.form })
        .then((response) => {
          if (response.data.status) {
            if(!this.isMobile){
              window.open(response.data.url,'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1200,height=800');
            }
            else{
              location.href = response.data.url;
            }
          }
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
    },
    components:{
      Header,
      Form
    }
  }

</script>